import { IUser } from 'shared/models/user';

class UserService {
  public getFullName({ forenames, surname }: IUser) {
    return `${forenames ?? ''} ${surname ?? ''}`.trim();
  }
}

export default new UserService();
